import { workerClient } from './api/workerClient';
import { apiEndpoints } from './api/endpoints';
import { Configuration } from '../types/configuration.types';

export const configurationService = {
  getConfigurations: async (): Promise<Configuration[]> => {
    const response = await workerClient.get<{ success: boolean; data: { configs: Configuration[] } }>(
      apiEndpoints.configurations.list()
    );
    return response.data.data?.configs || [];
  },

  getConfiguration: async (key: string): Promise<Configuration | null> => {
    const response = await workerClient.get<{ success: boolean; data: Configuration }>(
      apiEndpoints.configurations.get(key)
    );
    return response.data.data || null;
  },

  updateConfiguration: async (key: string, value: string, description?: string): Promise<Configuration> => {
    const response = await workerClient.put<{ success: boolean; data: Configuration }>(
      apiEndpoints.configurations.update(key),
      { value, description }
    );
    return response.data.data!;
  }
};
